import { types } from 'mobx-state-tree';
import type { Instance } from 'mobx-state-tree';

const EducationModel = types.model('EducationModel', {
    organizationId: types.maybeNull(types.number),
    title: types.maybeNull(types.string),
    startDate: types.maybeNull(types.string),
    endDate: types.maybeNull(types.string),
    description: types.maybeNull(types.string),
    organizationName: types.maybeNull(types.string),
    website: types.maybeNull(types.string),
    location: types.maybeNull(types.string),
});

export type TypeEducationModel = Instance<typeof EducationModel>;
export default EducationModel;
